import React from "react";
import "materialize-css/dist/js/materialize.min.js";
import ComponentHeader from "../components/ComponentHeader";
import topPerformer from "../images/awards/topperformer.JPG";
import bestTeam from "../images/awards/bestteam.JPG";
import coo from "../images/awards/coo.jpg";
import imss from "../images/awards/imss.jpg";
import strategy from "../images/awards/strategy.jpg";
import "bootstrap/dist/css/bootstrap.css";
import Carousel from "react-bootstrap/Carousel";

class Certification extends React.Component {
  render() {
    return (
      <div className="container flow-text education-container">
        <ComponentHeader heading={"Awards"} variant="dark" />
        <Carousel interval={null}>
          <Carousel.Item>
            <img className="img-slider" src={topPerformer} alt="Second" />
            <Carousel.Caption></Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="img-slider" src={bestTeam} alt="First" />
            <Carousel.Caption></Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="img-slider" src={coo} alt="Third " />
            <Carousel.Caption></Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="img-slider" src={imss} alt="fourth " />
            <Carousel.Caption></Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="img-slider" src={strategy} alt="Fifth" />
            <Carousel.Caption></Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
    );
  }
}

export default Certification;
